import React from "react";
import styles from './Input.styl';

function Input(props) {
	const {x, y, width = 140, type = 'text', title, zIndex = '10',labelWidth = 500,
		dangerFlag = false, ...addProps } = props
	return <div className={styles.selectWrapper} style={{top: y + 'px', left: x + 'px', zIndex}}>
		{ title
			? <p className={styles.selectLabel} style={{maxWidth:labelWidth + 'px'}}>{title}</p>
			: null
		}
		<input
			className={`${styles.selectBase} ${dangerFlag ? styles.danger : ''}`}
			type={type}
			style={{width:width + 'px'}}
			{...addProps}
		/>
	</div>
}

export default Input;



// WEBPACK FOOTER //
// ./src/react/ui/features/Input/Input.jsx